import { FC } from "react";
import {
  NativeProps,
  withNativeProps,
} from "@/utils/components-utils/native-props";
import React from "react";
import classNames from "classnames";
import styles from "./safe-area.module.scss";

export type SafeAreaProps = {
  position: "top" | "bottom";
} & NativeProps;

export const SafeArea: FC<SafeAreaProps> = (props) => {
  const getCLassName = () => {
    if (props.position === "top") {
      return classNames(
        styles.rfSafeArea,
        styles.rfSafeArea__top,
        props.className || ""
      );
    }
    return classNames(
      styles.rfSafeArea,
      styles.rfSafeArea__bottom,
      props.className || ""
    );
  };
  return withNativeProps(props, <div className={getCLassName()} />);
};
